import { useRef, useEffect } from "react";
import { deepAccess } from "../../utils/object-util";
import Divider from "../divider";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FilterPanel(_ref) {
  let {
    options,
    descriptors,
    selectedIndex,
    onSelect,
    updateFilter
  } = _ref;
  const activeOptions = options.filter(opt => descriptors.find(desc => desc.dataIndex === opt.dataIndex));
  const hasSelected = !!selectedIndex && !!activeOptions.find(opt => opt.dataIndex === selectedIndex);
  const focusRef = useRef(null);
  useEffect(() => focusRef.current?.focus?.(), [focusRef]);
  const panels = activeOptions.map(opt => {
    const desc = descriptors.find(desc => desc.dataIndex === opt.dataIndex);
    if (desc) {
      const style = {
        display: desc.dataIndex === selectedIndex ? "initial" : "none"
      };
      const panel = opt.renderPanel({
        label: opt.label,
        validateStatus: opt.validateStatus,
        operator: desc.operator,
        value: desc.value,
        setOperator(event) {
          updateFilter(desc.dataIndex, {
            operator: deepAccess(event, "target.value", event)
          });
        },
        setValue(event) {
          updateFilter(desc.dataIndex, {
            value: deepAccess(event, "target.value", event)
          });
        },
        setDescriptor(_ref2) {
          let {
            operator,
            value
          } = _ref2;
          updateFilter(desc.dataIndex, {
            operator,
            value
          });
        },
        close() {
          onSelect(null);
        },
        selected: desc.dataIndex === selectedIndex,
        focusRef: desc.dataIndex === selectedIndex ? focusRef : undefined
      });
      return /*#__PURE__*/_jsx("div", {
        style: style,
        children: panel
      }, desc.dataIndex);
    }
    return null;
  }).filter(el => el);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasSelected && /*#__PURE__*/_jsx(Divider, {
      my: 2
    }), panels]
  });
}
export default FilterPanel;